// Deps
import request from 'utils/request'
import store from 'store'

// Actions
import { setCities } from 'store/site/actions'

const sysServices = {
	// Company
	getCities: () => {
		return new Promise((resolve, reject) => {
			request.post('get-city-district', false, (payload, status, request) => {
				if(payload) {
					const cities = payload.map((city) => ({
						...city,
						value: city.id,
						label: city.name,
					}))
					store.dispatch(setCities(cities));
					resolve(cities);
				}
				else {
					reject(false);
				}
			});
		});
	},
	getDistricts: (cityID) => {
		return new Promise((resolve, reject) => {
			request.post('get-city-district', { city_id: cityID }, (payload, status, request) => {
				if(payload) {
					const districts = payload.map((district) => ({
						...district,
						value: district.id,
						label: district.name,
					}));
					resolve(districts);
				}
				else {
					reject(false);
				}
			});
		});
	},
}

export default sysServices